module.exports = __webpack_public_path__ + "img/dancing.36e52c91.png";